import React from "react";
import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { loadingTypes } from "../../Utils/constant";
import { SpinnerBlock } from "../../Utils/CustomComponent";
import { formatNumbers } from "../../Utils";

const NSFStatsCards = ({}) => {
  const { data: nsfData, status: nsfStatus } = useSelector(
    (state) => state.nsf.nsfData
  );
  return nsfStatus === loadingTypes.loading ? (
    <Row className="mb-1 gx-0">
      <Col md={12} className="px-3 py-4">
        <div
          className="d-flex align-items-center justify-content-center p-4 rounded"
          style={{ minHeight: "80px" }}
        >
          <SpinnerBlock height="10vh" />
        </div>
      </Col>
    </Row>
  ) : (
    nsfData && nsfStatus === loadingTypes.fulfilled && (
      <Row className=" mb-1 gx-0">
        {/* NSF Alert Banner */}
        <Col md={12} className="px-3 py-4" style={{ borderColor: "navy" }}>
          <div
            className="d-flex align-items-center justify-content-between p-4 rounded"
            style={{
              backgroundColor: "#fdf2f2",
              border: "1px solid #fecaca",
              borderRadius: "5px",
              minHeight: "80px",
            }}
          >
            <div className="d-flex align-items-center">
              <div
                className="d-flex align-items-center justify-content-center me-3"
                style={{
                  backgroundColor: "#fee2e2",
                  borderRadius: "50%",
                  width: "48px",
                  height: "48px",
                  color: "#dc2626",
                }}
              >
                <svg
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2L1 21h22L12 2zm0 3.99L19.53 19H4.47L12 5.99zM11 16h2v2h-2v-2zm0-6h2v4h-2v-4z" />
                </svg>
              </div>
              <div>
                <div
                  className="fw-bold text-dark fs-5 mb-1"
                  style={{ color: "#7f1d1d" }}
                >
                  {nsfData?.totalRecords} Loan(s) Affected Due to Insufficient
                  Funds
                </div>
                <div style={{ color: "#b91c1c" }}>
                  Total failed payment(s):{" "}
                  <strong>{formatNumbers(Math.abs(nsfData?.TotalNSFAmount))}</strong>
                </div>
              </div>
            </div>
            <div></div>
          </div>
        </Col>
      </Row>
    )
  );
};

export default NSFStatsCards;
